const  LK_LogOut=({color,width,height})=>{
    return(
        <svg fill={color} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
        {/* <defs>
            <style>
            .cls-1 {
                fill: #005c8e;
                stroke-width: 0px;
            }
            </style>
        </defs> */}
        <path  d="M116.78,58.49l-40.71-23.5v21.34H26.69v4.33h49.39v21.34l40.71-23.5ZM108.12,58.49l-27.71,16v-32l27.71,16Z"/>
        <path  d="M70.07,111.98H13.2v-.05c-4.38,0-7.94-3.56-7.94-7.94h-.05V5h64.87v25.88h5V0H.2v103.99c0,7.18,5.82,13,13,13h61.87v-30.91h-5v25.9Z"/>
        </svg>   
    );
};

export default LK_LogOut;
